import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icon';
import { KEYCODE } from '../../util';

/* eslint-disable react/prefer-stateless-function */
export default class Sort extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    rtl: PropTypes.bool,
    className: PropTypes.string,
    sort: PropTypes.object,
    sortIcons: PropTypes.object,
    initialOrder: PropTypes.oneOf(['asc', 'desc']),
    onSort: PropTypes.func,
    dataIndex: PropTypes.string,
    locale: PropTypes.object,
  };

  static defaultProps = {
    sort: {},
    initialOrder: 'desc',
  };

  // 渲染排序
  renderSort() {
    const { prefix, sort, sortIcons, dataIndex, locale, rtl } = this.props;
    const sortStatus = sort[dataIndex];
    const map = {
      desc: 'arrows-long-down',
      asc: 'arrows-long-up',
    };

    const icons = ['asc', 'desc'].map(sortOrder => {
      return (
        <span
          key={sortOrder}
          style={{ cursor: 'pointer' }}
          className={sortStatus === sortOrder ? 'current' : ''}
        >
          {sortIcons ? sortIcons[sortOrder] : <Icon rtl={rtl} type={map[sortOrder]} size="small" />}
        </span>
      );
    });

    return (
      <span
        role="button"
        tabIndex="0"
        aria-label={locale[sortStatus]}
        className={`${prefix}table-sort`}
        onClick={this.handleClick}
        onKeyDown={this.keydownHandler}
      >
        {icons}
      </span>
    );
  }

  handleClick = () => {
    const { sort, dataIndex, initialOrder } = this.props;
    let order = initialOrder;
    if (sort[dataIndex]) {
      order = sort[dataIndex] === 'desc' ? 'asc' : 'desc';
    }
    this.onSort(dataIndex, order);
  };

  keydownHandler = e => {
    e.preventDefault();
    e.stopPropagation();

    if (e.keyCode === KEYCODE.ENTER) {
      this.handleClick();
    }
  };

  onSort = (dataIndex, order) => {
    const sort = {};
    sort[dataIndex] = order;

    this.props.onSort(dataIndex, order, sort);
  };

  render() {
    return this.renderSort();
  }
}
